
import 'bootstrap/dist/css/bootstrap.min.css';
import { Button, Container,Col,
    Modal,
    ModalBody,
    ModalHeader,
    ModalTitle,
    ModalFooter,
     Row,Card,CardBody,CardTitle,FormControl,Form,FormGroup, InputGroup, CardHeader } from 'react-bootstrap';
import './pol.css'
import CurrencyBitcoinIcon from '@mui/icons-material/CurrencyBitcoin';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import PaymentIcon from '@mui/icons-material/Payment';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import { useState } from 'react';
import Deposit from "./kdeposit"


export default function Kpack() {
    const timy = new Date()
    const limo = timy.toDateString()
    const [selectedComponent, setSelectedComponent] = useState('pack');

   return (
    <>
    {
      selectedComponent === "pack" && (
    <Container fluid>
    <div style={{ color:"white", display:"flex", justifyContent:"space-between"}} className="page-title-box">
    <h5>Deposit Options</h5>
        <div >
            <Button size='sm'  >
            &nbsp;{limo}
              {/* <CalendarMonthIcon/> */}
            </Button>
        </div>
    </div>

       <Row >
        <div className='pol' style={{}}>
        <Card className='pol2' style={{backgroundColor: "darkblue"}}>
      <Card.Header style={{padding:"1.4rem .9rem",color:"white", borderBottom:"1px solid white",  backgroundImage: "linear-gradient(112.1deg, rgba(32, 38, 57, 1) 11.4%, rgba(63, 76, 119, 1) 70.2%)"}}>
        Starter</Card.Header>
      <Card.Body style={{ backgroundImage:"radial-gradient(circle 815px at 23.4% -21.8%, rgb(11 25 63) 0.2%, rgba(0, 0, 0, 1) 100.2%)"}}>
        <div style={{padding:".8rem",backgroundImage: "radial-gradient(circle 815px at 23.4% -21.8%, rgba(9, 29, 85, 1) 0.2%, rgba(0, 0, 0, 1) 100.2%)"}}>
        <Card.Text style={{color:"white",padding: "2rem 1rem"}} >
        <div style={{display:"flex", justifyContent:"space-between", borderBottom:"1px solid white", padding:"1rem 0rem"}}>
         <div>  ROI</div><div>22%-34% returns</div>
         </div>
         <div style={{display:"flex", justifyContent:"space-between",borderBottom:"1px solid white", padding:"1rem 0rem"}}>
         <div> MINIMUM</div><div>$3,000</div>
         </div>
         <div style={{display:"flex", justifyContent:"space-between",borderBottom:"1px solid white", padding:"1rem 0rem"}}>
         <div> MAXIMUM</div><div>$50,000</div>
         </div>
         <div style={{display:"flex", justifyContent:"space-between",borderBottom:"1px solid white", padding:"1rem 0rem"}}>
         <div> 5% trade comission</div><div></div>
         </div>
         <div style={{display:"flex", justifyContent:"space-between",borderBottom:"1px solid white", padding:"1rem 0rem"}}>
         <div> 24/7 active support</div><div></div>
         </div>
        </Card.Text>
        <Button onClick={()=> {setSelectedComponent('form')}} style={{margin:"1rem 0", width:"100%", padding:".7rem",borderRadius:"5px",
         backgroundImage:"linear-gradient(112.1deg, rgba(32, 38, 57, 1) 11.4%, rgba(63, 76, 119, 1) 70.2%)"}}>Make Deposit</Button>
        </div>
      </Card.Body>
      </Card>


      <Card className='pol2' style={{ backgroundColor: "darkblue"}}>
      <Card.Header style={{padding:"1.4rem .9rem",color:"white",borderBottom:"1px solid white",  backgroundImage: "linear-gradient(112.1deg, rgba(32, 38, 57, 1) 11.4%, rgba(63, 76, 119, 1) 70.2%)"}}>
        Tier I</Card.Header>
      <Card.Body style={{ backgroundImage:"radial-gradient(circle 815px at 23.4% -21.8%, rgb(11 25 63) 0.2%, rgba(0, 0, 0, 1) 100.2%)"}}>
        <div style={{padding:".8rem",backgroundImage: "radial-gradient(circle 815px at 23.4% -21.8%, rgba(9, 29, 85, 1) 0.2%, rgba(0, 0, 0, 1) 100.2%)"}}>
        <Card.Text style={{color:"white",padding: "2rem 1rem"}} >
        <div style={{display:"flex", justifyContent:"space-between", borderBottom:"1px solid white", padding:"1rem 0rem"}}>
         <div>  ROI</div><div>43%-48% returns</div>
         </div>
         <div style={{display:"flex", justifyContent:"space-between",borderBottom:"1px solid white", padding:"1rem 0rem"}}>
         <div> MINIMUM</div><div>$51,000</div>
         </div>
         <div style={{display:"flex", justifyContent:"space-between",borderBottom:"1px solid white", padding:"1rem 0rem"}}>
         <div> MAXIMUM</div><div>$100,000</div>
         </div>
         <div style={{display:"flex", justifyContent:"space-between",borderBottom:"1px solid white", padding:"1rem 0rem"}}>
         <div> 5% trade comission</div><div></div>
         </div>
         <div style={{display:"flex", justifyContent:"space-between",borderBottom:"1px solid white", padding:"1rem 0rem"}}>
         <div> 24/7 active support</div><div></div>
         </div>
        </Card.Text>
        <Button onClick={()=> {setSelectedComponent('form')}} style={{margin:"1rem 0", width:"100%", padding:".7rem",borderRadius:"5px",
         backgroundImage:"linear-gradient(112.1deg, rgba(32, 38, 57, 1) 11.4%, rgba(63, 76, 119, 1) 70.2%)"}}>Make Deposit</Button>
        </div>
      </Card.Body>
      </Card>
        </div>


        <div className='pol' style={{ margin:"1rem 0"}}>
        <Card className='pol2' style={{backgroundColor: "darkblue"}}>
      <Card.Header style={{padding:"1.4rem .9rem",color:"white", borderBottom:"1px solid white",  backgroundImage: "linear-gradient(112.1deg, rgba(32, 38, 57, 1) 11.4%, rgba(63, 76, 119, 1) 70.2%)"}}>
        Tier II</Card.Header>
      <Card.Body style={{ backgroundImage:"radial-gradient(circle 815px at 23.4% -21.8%, rgb(11 25 63) 0.2%, rgba(0, 0, 0, 1) 100.2%)"}}>
        <div style={{padding:".8rem",backgroundImage: "radial-gradient(circle 815px at 23.4% -21.8%, rgba(9, 29, 85, 1) 0.2%, rgba(0, 0, 0, 1) 100.2%)"}}>
        <Card.Text style={{color:"white",padding: "2rem 1rem"}} >
        <div style={{display:"flex", justifyContent:"space-between", borderBottom:"1px solid white", padding:"1rem 0rem"}}>
         <div>  ROI</div><div>81%-87% returns</div>
         </div>
         <div style={{display:"flex", justifyContent:"space-between",borderBottom:"1px solid white", padding:"1rem 0rem"}}>
         <div> MINIMUM</div><div>$101,000</div>
         </div>
         <div style={{display:"flex", justifyContent:"space-between",borderBottom:"1px solid white", padding:"1rem 0rem"}}>
         <div> MAXIMUM</div><div>$500,000</div>
         </div>
         <div style={{display:"flex", justifyContent:"space-between",borderBottom:"1px solid white", padding:"1rem 0rem"}}>
         <div> 5% trade comission</div><div></div>
         </div>
         <div style={{display:"flex", justifyContent:"space-between",borderBottom:"1px solid white", padding:"1rem 0rem"}}>
         <div> 24/7 active support</div><div></div>
         </div>
        </Card.Text>
        <Button onClick={()=> {setSelectedComponent('form')}} style={{margin:"1rem 0", width:"100%", padding:".7rem",borderRadius:"5px",
         backgroundImage:"linear-gradient(112.1deg, rgba(32, 38, 57, 1) 11.4%, rgba(63, 76, 119, 1) 70.2%)"}}>Make Deposit</Button>
        </div>
      </Card.Body>
      </Card>


      <Card className='pol2' style={{ backgroundColor: "darkblue"}}>
      <Card.Header style={{padding:"1.4rem .9rem",color:"white",borderBottom:"1px solid white",  backgroundImage: "linear-gradient(112.1deg, rgba(32, 38, 57, 1) 11.4%, rgba(63, 76, 119, 1) 70.2%)"}}>
        Tier III</Card.Header>
      <Card.Body style={{ backgroundImage:"radial-gradient(circle 815px at 23.4% -21.8%, rgb(11 25 63) 0.2%, rgba(0, 0, 0, 1) 100.2%)"}}>
        <div style={{padding:".8rem",backgroundImage: "radial-gradient(circle 815px at 23.4% -21.8%, rgba(9, 29, 85, 1) 0.2%, rgba(0, 0, 0, 1) 100.2%)"}}>
        <Card.Text style={{color:"white",padding: "2rem 1rem"}} >
        <div style={{display:"flex", justifyContent:"space-between", borderBottom:"1px solid white", padding:"1rem 0rem"}}>
         <div>  ROI</div><div>186%-210% returns</div>
         </div>
         <div style={{display:"flex", justifyContent:"space-between",borderBottom:"1px solid white", padding:"1rem 0rem"}}>
         <div> MINIMUM</div><div>$501,000</div>
         </div>
         <div style={{display:"flex", justifyContent:"space-between",borderBottom:"1px solid white", padding:"1rem 0rem"}}>
         <div> MAXIMUM</div><div>Unlimited</div>
         </div>
         <div style={{display:"flex", justifyContent:"space-between",borderBottom:"1px solid white", padding:"1rem 0rem"}}>
         <div> 5% trade comission</div><div></div>
         </div>
         <div style={{display:"flex", justifyContent:"space-between",borderBottom:"1px solid white", padding:"1rem 0rem"}}>
         <div> 24/7 active support</div><div></div>
         </div>
        </Card.Text>
        <Button onClick={()=> {setSelectedComponent('form')}} style={{margin:"1rem 0", width:"100%", padding:".7rem",borderRadius:"5px",
         backgroundImage:"linear-gradient(112.1deg, rgba(32, 38, 57, 1) 11.4%, rgba(63, 76, 119, 1) 70.2%)"}}>Make Deposit</Button>
        </div>
      </Card.Body>
      </Card>
        </div>
             
         </Row>
         </Container>
      )}
         {
      selectedComponent === "form" && (
        <>
        <Deposit/>
        </>
      )}
         </>
   )
}